import { jsx } from "panel";
import { delayedAttrRemove } from "panel/build/component-utils/hook-helpers";
import { ItemsMenuEl } from "common/components/items-menu";
import { ContextPanelEl } from "common/widgets/context-panel";
export function template() {
  const { keydownProxyEl, searchFilter, tooltipData } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-child-menu"
  }, /* @__PURE__ */ jsx(ItemsMenuEl, {
    attrs: {
      elref: `mainSelectionMenu`,
      "empty-message": `No items found`,
      multiple: this.attr(`multiple`),
      "search-filter": searchFilter,
      sections: this.helpers.getMenuSections(),
      "start-focus-on-selected": true
    },
    on: {
      click: (ev) => ev.stopPropagation(),
      clickItem: this.helpers.handleItemClick,
      focusItem: this.helpers.showItemDetails
    },
    props: {
      keydownProxyEl,
      customSearchMatcherFn: this.helpers.customSearchMatcherFn
    }
  }), this.attr(`open`) && tooltipData && /* @__PURE__ */ jsx(ContextPanelEl, {
    hook: { remove: delayedAttrRemove(`tooltip-data`, null) },
    attrs: {
      "tooltip-data": tooltipData,
      "position-parent-selector": `mp-drop-menu`,
      elRef: `contextPanel`
    },
    on: {
      tooltipContextAction: this.helpers.propagateEvent,
      tooltipContextEditDescription: this.helpers.propagateEvent
    }
  }));
}
